import angular from 'angular';
import moment from 'moment';

angular.module('cloudX').directive('cxEndFiscalYearPicker', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: `<div>
        <tags-input
          ng-model="ctrl.selected"
          placeholder="{{('EndFiscalYear'|translate)}}"
          display-property="label"
          key-property="id"
          on-tag-added="ctrl.updateValue()"
          on-tag-removed="ctrl.updateValue()"
          replace-spaces-with-dashes="false"
          add-from-autocomplete-only="true"
          min-length="1"
          class="bootstrap">
          <auto-complete
            source="ctrl.getSuggestions($query)"
            load-on-focus="true"
            load-on-empty="true"
            display-property="label"
            min-length="0"></auto-complete>
        </tags-input>
      </div>`,
      require: ['ngModel', 'cxEndFiscalYearPicker'],
      link: function($scope, el, attrs, controllers) {
        if (!controllers || controllers.length !== 2) return;
        const [ngModel, ctrl] = controllers;
        ctrl.view2model = function(value) {
          ngModel.$setViewValue(value);
        };

        // when angular detects a change to the model,
        // we update our inner value
        ngModel.$render = function() {
          ctrl.setValue(ngModel.$viewValue);
        };
      },
      controllerAs: 'ctrl',
      controller: [
        '$http',
        'appUrls',
        '$translate',
        'dataCache',
        '$filter',
        function($http, appUrls, $translate, dataCache, $filter) {
          const ctrl = this;
          ctrl.selected = [];
          ctrl.options = null;
          ctrl.tmpValue = null; //Init after loading
          ctrl.findOption = function(code) {
            if (code == null || !ctrl.options || ctrl.options.length === 0) return null;
            return ctrl.options.find(el => el.id === code);
          };
          ctrl.getSuggestions = function(search) {
            return $filter('filter')(ctrl.options, search);
          };
          dataCache
            .ready()
            .then(() => {
              const data = dataCache.getArray('fiscalYears');
              if (!!data) return data; //Get fiscalYears from dataCache

              //Not found, retrieve from backend
              return $http.get(`${appUrls.api}/api/relation/fiscalYears`).then(({ data }) => {
                const years = data.map(fiscalYear => ({
                  id: fiscalYear,
                  label: moment.utc(fiscalYear).format('D/MM'),
                }));
                //Store in dataCache
                dataCache.update('fiscalYears', years);
                return years;
              });
            })
            .then(years => {
              ctrl.options = [
                {
                  id: '0001-01-01',
                  label: $translate.instant('EmptyFiscalYear'),
                },
                ...years,
              ];
              if (!!ctrl.tmpValue) {
                ctrl.selected = ctrl.tmpValue.map(x => ctrl.findOption(x));
              }
            });
          ctrl.updateValue = function() {
            ctrl.view2model(ctrl.selected.map(x => x.id));
          };
          ctrl.setValue = function(value) {
            ctrl.tmpValue = null;
            if (value !== null && typeof value !== 'undefined' && angular.isArray(value)) {
              if (ctrl.options !== null) {
                ctrl.selected = value.map(x => ctrl.findOption(x));
              } else {
                //Options not loaded yet
                ctrl.tmpValue = value;
              }
            } else {
              ctrl.selected = [];
            }
          };
        },
      ],
    };
  },
]);
